import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import HeaderComponent from "./components/HeaderComponent/HeaderComponent";
import HeroComponent from "./components/HeroComponent/HeroComponent";
import FooterComponent from "./components/FooterComponent/FooterComponent";
import AboutDirelightSection from "./components/AboutDirelightSection/AboutDirelightSection";

const GamesPage = lazy(() => import("./pages/GamesPage"));

const HomePage: React.FC = () => (
    <div id="hero">
        <HeroComponent />
        <AboutDirelightSection />
    </div>
);

const PageFallback: React.FC = () => (
    <div className="min-h-[40vh] bg-[#0B0907]" aria-hidden="true" />
);

function App() {
    return (
        <Router>
            <div className="App flex min-h-screen flex-col overflow-x-hidden">
                <HeaderComponent />

                <main className="flex-1">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route
                            path="/games"
                            element={
                                <Suspense fallback={<PageFallback />}>
                                    <GamesPage />
                                </Suspense>
                            }
                        />
                    </Routes>
                </main>

                <FooterComponent />
            </div>
        </Router>
    );
}

export default App;
